import { Link, isRouteErrorResponse, useRouteError } from 'react-router';

import { Button } from '@/components/ui/button';

export function ErrorPage() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong';
  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="font-cond text-2xl font-extrabold">That did not work</h1>
      <p className="max-w-md text-ink2">{message}</p>
      <Link to="/">
        <Button variant="primary">Back to the dashboard</Button>
      </Link>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="p-7 text-center text-ink3">
      <h1 className="font-cond text-xl font-extrabold text-ink">Page not found</h1>
      <p className="mt-2">
        <Link to="/" className="font-semibold text-orange-ink underline">
          Back to the dashboard
        </Link>
      </p>
    </div>
  );
}
